<div class="container">
  <h1>Privacy Policy</h1>

  <h4>1. We respect your privacy</h4>
  <div class="section">
    <p><strong>Business Name</strong> respects your right to privacy and this policy sets out how we collect and treat your personal information. “Personal information” is information we hold which is identifiable as being about you.</p>
  </div>

  <h4>2. What personal information we collect</h4>
  <div class="section">
    <p>We may collect the following types of personal information from you:</p>
    <ul>
      <li>Name</li>
      <li>Billing address</li>
      <li>Shipping address</li>
      <li>Phone number</li>
      <li>Email address</li>
      <li>Information about the goods or services you have ordered</li>
      <li>Information from enquiries you have made</li>
      <li>Communications between us</li>
    </ul>
  </div>

  <h4>3. How we collect your personal information</h4>
  <div class="section">
    <p>We collect personal information from you in a variety of ways, including: when you interact with us electronically or in person; when you access our website; and when we provide our services to you.</p>
  </div>

  <h4>4. Use of your personal information</h4>
  <div class="section">
    <p>We use your information to provide our service to you. We also use it to improve our service and to notify you of opportunities that we think you might be interested in.</p>
    <p>We do not provide your information to third parties, except that we may provide your information to our business partners, such as Australia Post, who assist us in the provision of our services to you.</p>
  </div>

  <h4>5. Security of your personal information</h4>
  <div class="section">
    <p>We take reasonable steps to protect your personal information. However, we are not liable for any unauthorized access to this information.</p>
  </div>

  <h4>6. Access to your personal information</h4>
  <div class="section">
    <p>You can access and update your personal information by logging in to your account using the email and password you registered with, on the “My Account” page.</p>
    <p>Alternatively, you can access your personal information by contacting <strong>Business Name</strong>. <strong>Business Name</strong> will provide a copy of the information free of charge. However, in certain circumstances, a “reasonable fee” may be charged to cover administrative costs for large or excessive requests.</p>
  </div>

  <h4>7. Complaints about privacy</h4>
  <div class="section">
    <p>If you have any complaints about our privacy practices, please contact us with details of your complaints. We take complaints very seriously and will respond shortly after receiving notice of your complaint.</p>
  </div>

  <h4>8. Changes</h4>
  <div class="section">
    <p>Please be aware that we may change this Privacy Policy in the future. The revised versions will be uploaded onto our website, so please check back from time to time.</p>
  </div>

  <h4>9. Website</h4>
  <div class="section">
    <h5>When you visit our website</h5>
    <p>When you come on to our website, we may collect certain information such as browser type, operating system, website visited immediately before coming to our site, etc. This information is used in an aggregated manner to analyze how people use our site, such that we can improve our service. More information regarding the use of the Website can be found in our <a href="#">Terms & Conditions</a>.</p>

    <h5>Cookies</h5>
    <p>As is very common for companies, we use cookies on our website. Cookies are very small files that a website uses to identify you when you return and store details about your use of the site. Cookies are not malicious programs that access or damage your computer. We use cookies to improve the experience of people using our website and in providing our online store. More information on our use of Cookies can be found in our <a href="#">Cookie Policy</a>.</p>

    <h5>Third party sites</h5>
    <p>Our site has links to other websites not owned or controlled by us. We are not responsible for these sites or the consequences of you going on to those sites.</p>
  </div>
</div>
